import { FilterIcon } from './filter-icon'
import { FilterItemButton } from './filter-item-button'
import { SidebarFilterSection } from './sidebar-filter-section'
import styles from './workout-type-filter.module.scss'
import { useFilterContext } from '../../context/filter-context'
import { WorkoutType } from '../../dao/core-dao'
import React from 'react'
import { useWorkoutTypes } from 'src/hook/use-workouts'

export const WorkoutTypeFilter = (): React.ReactElement => {
  const { workoutFilter, toggleFilterEntry } = useFilterContext()
  const { data: allTypes = [] } = useWorkoutTypes()

  const handleToggleSelectedType = (toggleValue: string): void => {
    toggleFilterEntry('types', toggleValue)
  }

  const renderHouseCategory = (type: WorkoutType, additionalClass?: string): React.ReactElement => {
    const isActive = workoutFilter?.types?.includes(type.id) ?? false
    return (
      <FilterItemButton
        className={`${styles.workoutTypeContainer} ${additionalClass}`}
        isActive={isActive}
        onClick={() => handleToggleSelectedType(type.id)}
      >
        <FilterIcon filterEntry={type} active={isActive} />
        <span
          className={`font-roboto-condensed text-xs leading-4 tracking-[0.5px] ${isActive ? 'text-ivory' : 'text-light-gray'}`}
        >
          {type.label}
        </span>
      </FilterItemButton>
    )
  }

  return <SidebarFilterSection title={'Workout Type'} items={allTypes} lineLimit={4} renderItem={renderHouseCategory} />
}
